import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=28a25f92&scoped=true"
import script from "./ModuleList.vue?vue&type=script&lang=js"
export * from "./ModuleList.vue?vue&type=script&lang=js"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=28a25f92&prod&scoped=true&lang=scss"
import style1 from "./ModuleList.vue?vue&type=style&index=1&id=28a25f92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a25f92",
  null
  
)

export default component.exports